import { useState } from 'react'

import useTranslations from '../../../hooks/useTranslations'
// import { downloadReport } from '../../../utils/customFunctions'
import BankPaymentReport from '../presentation/BankPaymentReport'
import FlexibleReport from '../presentation/FlexibleReport'
import InventoryTable from '../presentation/InventoryTable'
import SalesReport from '../presentation/SalesReport'
import StockReport from '../presentation/StockReport'
import TallyReports from '../presentation/TallyReports'

const report = () => {
  const { t } = useTranslations()

  const [activeTab, setActiveTab] = useState('bankPayment')

  const [viewPreviousHistory, setViewPreviousHistory] = useState({
    open: false,
    data: [],
    type: '',
  })

  const handleTabChange = tab => {
    setActiveTab(tab)
  }

  const tabList = [
    {
      label: 'rpt_BankPayment',
      key: 'bankPayment',
      Component: <BankPaymentReport />,
    },
    {
      label: 'rpt_InventoryTable',
      key: 'inventoryTable',
      Component: <InventoryTable {...{ activeTab }} />,
    },
    {
      label: 'rpt_SalesReport',
      key: 'salesReport',
      Component: (
        <SalesReport
          {...{
            activeTab,
            viewPreviousHistory,
            setViewPreviousHistory,
          }}
        />
      ),
    },
    {
      label: 'rpt_StockReport',
      key: 'stockReport',
      Component: <StockReport />,
    },
    {
      label: 'rpt_FlexibleReport',
      key: 'flexibleReport',
      Component: <FlexibleReport />,
    },
    {
      label: 'rpt_TallyReports',
      key: 'tallyReports',
      Component: <TallyReports />,
    },
  ]

  return { t, activeTab, handleTabChange, tabList }
}

export default report
